import React from "react";
import Typography from "@mui/material/Typography";

function HexagoneTitle() {
  return (
    <div className="flex justify-center items-center px-2 py-2 text-hx2 font-black text-black">
      hexagone
    </div>
  );
}

export default HexagoneTitle;
